import { Building2, Info } from 'lucide-react';

export default function NewOrgNotice({ compact = false }: { compact?: boolean }) {
  return (
    <div
      className="rounded-lg border border-amber-500/30 bg-amber-500/5 p-4"
      data-testid="new-org-notice"
    >
      <div className="flex gap-3">
        {compact ? (
          <Info className="h-4 w-4 text-amber-600 shrink-0 mt-0.5" />
        ) : (
          <Building2 className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
        )}
        <div className="text-sm">
          <p className="font-medium">This sets up a new organisation.</p>
          <p className="text-muted-foreground mt-1">
            If your company already uses BitSwan, do not sign up here — ask an
            admin in your organisation to invite you instead, so you join the
            one your colleagues are already working in.
          </p>
        </div>
      </div>
    </div>
  );
}
